import { makeStyles } from 'tss-react/mui';

const styles = makeStyles()((theme) => ({
  linkButton: {
    color: theme.tokens.colors.original.brand.primary,
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    outline: 'none',
    fontSize: theme.tokens.typography.variant.body3.fontSize,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  linkButton_tertiary: {
    color: theme.tokens.colors.text.light.tertirary,
    textUnderlineOffset: `${theme.px(5)}px`,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

export default styles;
